<app-empresadeshidratadora-list 
    [result]="empresas" [lastFilter]="payloadRecintosPIA"
    [mode]="recintoListMode" [readonly]="readonly" 
    (search)="onSearchLazy($event)" (view)="onViewHandler($event)" (delete)="onDeleteEmpresa($event)" (undoDelete)="onUndoDeleteEmpresa($event)">
</app-empresadeshidratadora-list>

<!-- Ventana de diálogo para añadir Empresas Deshidratadoras a la solicitud -->
<app-empresadeshidratadora-list-dialog [visible]="recintoPIAListDialogVisible" [dialogFilter]="dialogFilter" (selectedEmpresas)="onSelectedEmpresasDeshidratadoras($event)"></app-empresadeshidratadora-list-dialog>

<!-- Ventana para mostrar el detalle de una Empresa Deshidratadora -->
<app-empresadeshidratadora-detail-dialog [visible]="recintoPIADetailVisible" [Id]="recintoPIAIdSelected" (closed)="onEmpresaDialogClosed($event)"></app-empresadeshidratadora-detail-dialog>
